import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { DuedateRangePicker } from "./duedate/DuedateRangePicker";

type Props = {
  type: "range";
} & FormItemProps<SaveTicketValues>;

export const DuedateInput = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("duedate");

  if (config && config.hidden) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.duedate.label");

  return (
    <Form.Item<SaveTicketValues>
      name="duedate"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.duedate.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "range" && <DuedateRangePicker />}
    </Form.Item>
  );
});
